/**
 * @ngdoc controller
 * @name AppController
 * @description The base controller
 * @constructor
 */
export default function AppController(Alerts, $state, User, environment, $location, $window, $rootScope) {
  'ngInject';
  this.loginData = () => {
    return $state.current.data.login;
  };

  this.state = $state;

  this.getStates = () => {
    return $state.get();
  };

  this.alerts = Alerts;

  //Sync Alerts every minute.
  Alerts.synchronizeAlerts(60 * 1000);

  Object.defineProperty(this, 'currentUser', {
    get: function () {
      return User.currentUser;
    }
  });

  let forceSSL = function (state) {
    if (!state.name.includes('app.ecourse.registration')) {
      if ($location.protocol() !== 'http') {
        $window.location.href = $location.absUrl().replace('https', 'http');
      }
    }
    else {
      if ($location.protocol() !== 'https') {
        $window.location.href = $location.absUrl().replace('http', 'https');
      }
    }
  };
  if(environment.name === 'Production') {
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      forceSSL(toState);
    });
    forceSSL($state.current);
  }


  this.site = environment.site;

  this.currentYear = new Date().getFullYear();
}



/** WEBPACK FOOTER **
 ** ./src/app/app.controller.js
 **/